<template>
  <div id="top-bar">
    <el-menu
      :router="true"
      :default-active="$route.name"
      class="top-bar-menu"
      active-text-color="#00B6D3"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item>
        <img src="@/assets/spc-full-logo.png" width="215" />
      </el-menu-item>

      <el-menu-item index="my-dashboard" v-if="$store.state.user.id"
        >My Dashboard</el-menu-item
      >

      <el-menu-item index="company-dashboard" v-if="$store.state.user.id"
        >Company Dashboard</el-menu-item
      >

      <el-submenu index="user" v-if="$store.state.user.id">
        <template slot="title"
          ><span class="submenu-title">{{
            $store.state.user.display_name
          }}</span></template
        >
        <el-menu-item index="2-1" @click="$emit('logOut')"
          >Log out</el-menu-item
        >
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "TopBar",
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
  },
  mounted() {
    console.log(this.$route.name);
  }
};
</script>

<style lang="scss" scoped>
#top-bar {
  height: 6rem;
  z-index: 2;
}

.top-bar-menu {
  li[role="menuitem"],
  .submenu-title {
    height: 6rem !important;
    line-height: 6rem !important;
    font-family: Lato-Semibold !important;
    font-size: 20px !important;
    color: rgba(0, 0, 0, 0.19) !important;
    letter-spacing: 0 !important;

    &:not(:first-child) {
      margin-left: 2.5rem;
    }

    &.is-active {
      border-bottom-width: 6px !important;
    }
  }

  .el-submenu {
    float: right;
  }
}
</style>
